import React from 'react'
import { Badge } from 'react-bootstrap'

function CustomLabel({ children }) {
    return (
        <Badge bg='light' text='dark'>
            {children}
        </Badge>
    )
}

export default CustomLabel